export default "__VITE_ASSET__DadvVLjx__"